<div class="header-entregas">
    <h1>Entregadores</h1>
</div>

<div class="card-entregadores-area">
    <mat-card class="card">

        <mat-card-header class="header-card">
          <div mat-card-avatar><mat-icon fontSet="material-icons-outlined">sports_motorsports</mat-icon></div>
          <mat-card-title>Entregador</mat-card-title>
          <mat-card-subtitle><mat-icon  fontSet="material-icons-outlined">place</mat-icon>Local de Destino</mat-card-subtitle>
        </mat-card-header>

        <img mat-card-image src="https://www.gmap.ro/MAPS/Google/base/roadmap/DN19_Oradea_Satu_Mare.jpg" alt="Photo of a Shiba Inu">
        
        <mat-card-content>
          <p>
              Informações do pedido que ele está levando
          </p>
        </mat-card-content>

    </mat-card>

    <mat-card class="card">
        <mat-card-header class="header-card">
          <div mat-card-avatar class="example-header-image"><mat-icon  fontSet="material-icons-outlined">sports_motorsports</mat-icon></div>
          <mat-card-title>Entregador</mat-card-title>
          <mat-card-subtitle><mat-icon  fontSet="material-icons-outlined">place</mat-icon>Local de Destino</mat-card-subtitle>
        </mat-card-header>
        <img mat-card-image src="https://www.gmap.ro/MAPS/Google/base/roadmap/DN19_Oradea_Satu_Mare.jpg" alt="Photo of a Shiba Inu">
        <mat-card-content>
          <p>
              Informações do pedido que ele está levando
          </p>
        </mat-card-content>
    </mat-card>

    <mat-card class="card">
        <mat-card-header class="header-card">
          <div mat-card-avatar class="example-header-image"><mat-icon  fontSet="material-icons-outlined">sports_motorsports</mat-icon></div>
          <mat-card-title>Entregador</mat-card-title>
          <mat-card-subtitle><mat-icon  fontSet="material-icons-outlined">place</mat-icon>Local de Destino</mat-card-subtitle>
        </mat-card-header>
        <img mat-card-image src="https://www.gmap.ro/MAPS/Google/base/roadmap/DN19_Oradea_Satu_Mare.jpg" alt="Photo of a Shiba Inu">
        <mat-card-content>
          <p>
              Informações do pedido que ele está levando
          </p>
        </mat-card-content>
    </mat-card>
</div>